export default __webpack_public_path__ + "static/media/4696@2x.b1a6e403.png";